import './bootstrap';

// Externals
import '@fancyapps/fancybox';
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import './wwdev/forms/index';
import './wwdev/lazysizes/index.js';
import './theme/theme';
import '@wwdev/functions/setEqualHeightsPerRow';


// Sections
import './sections/visual';
import './sections/team';
import './sections/projects';

// Vendor
import './vendor/contentlist/item';
import './vendor/whatsapp';